import type { EventDto } from '../../api/types';
import { countParticipants, isEventFull } from '../events/participants';

// Цвет стола на плане по ближайшему актуальному мероприятию
export type TableTone = 'default' | 'open' | 'private' | 'full';

export type TableIndicator = {
  tone: TableTone;
  occupied: number;
  capacity: number;
};

/**
 * Приоритет: нет мест (red) > приватное (blue) > есть места (green).
 * Берётся первое мероприятие, которое ещё не закончилось (список отсортирован по startAt).
 * pending-участники занимают место, поэтому считаются в occupied.
 */
export function computeTableIndicator(events: EventDto[], nowMs: number): TableIndicator | null {
  const event = events.find((e) => {
    const endAtMs = new Date(e.endAt).getTime();
    return Number.isFinite(endAtMs) && endAtMs >= nowMs;
  });
  if (!event) return null;

  const tone: TableTone = isEventFull(event) ? 'full' : event.visibility === 'private' ? 'private' : 'open';
  return { tone, occupied: countParticipants(event), capacity: event.maxParticipants };
}
